export default "__VITE_ASSET__4814d7a0__"